import { factoryPermission } from "@/models";

export const ConfigPermission = {
  MATERIALS: factoryPermission("Config.Materials"),
  ASSIGN_MATERIALS: factoryPermission("Config.AssignedMaterials"),
} as const;
